<template>
  <!-- BEGIN BODY -->
<div class="page-md login">
<!-- BEGIN SIDEBAR TOGGLER BUTTON -->
<div class="menu-toggler sidebar-toggler">
</div>
<!-- END SIDEBAR TOGGLER BUTTON -->
<!-- BEGIN LOGO -->
<div class="logo">
  <a href="index.html">
  <img src="" alt=""/>
  </a>
</div>
<!-- END LOGO -->
<!-- BEGIN LOGIN -->
<div class="content">
  <!-- BEGIN LOGIN FORM -->
  <form class="login-form" action="index.html" method="post">
    <h3 class="form-title">用户登录<small>Sign In</small></h3>
    <div class="alert alert-danger" :class="{'display-hide': ui.ready}">
      <button class="close" data-close="alert"></button>
      <span>请填写用户名和密码. </span>
    </div>
    <div class="form-group">
      <!--ie8, ie9 does not support html5 placeholder, so we just show field title for that-->
      <label class="control-label visible-ie8 visible-ie9">Username</label>
      <input class="form-control form-control-solid placeholder-no-fix" v-model="biz.username" type="text" autocomplete="off" @keypress="press" placeholder="Username" name="username"/>
    </div>
    <div class="form-group">
      <label class="control-label visible-ie8 visible-ie9">Password</label>
      <input class="form-control form-control-solid placeholder-no-fix" v-model="biz.pwd" type="password" autocomplete="off" @keypress="press" placeholder="Password"/>
    </div>
    <div class="form-actions">
      <button type="button" @click="submit" :disabled="ui.busying" class="btn btn-success uppercase center-block"><i v-show="ui.busying" class='fa fa-spinner fa-spin'></i>确定</button>
    </div>

    <div class="create-account">
      <p>
        <!-- <a href="javascript:;" id="register-btn" class="uppercase">Create an account</a> -->
      </p>
    </div>
  </form>
  <!-- END LOGIN FORM -->
  <!-- END REGISTRATION FORM -->
</div>
<div class="copyright">
   2019 © 康业物业管理（中山）有限公司.
</div>

</div>
<!-- END BODY -->
</template>
<script>
  import {MSG_ID, SER_RESP_CODE, K_LOGINED_USER, DEFAULT_EXPIRE} from '../../lib/constant'
  import db from '../../store/local'
  import mixins from '../../mixins'
  // import logger from '../lib/utils/logger'
  import http from '../../lib/utils/request'
  require('../../lib/utils/cryptojs/cryptojs.js') // code executes and sets the object 'Crypto' in window object
  let crypto = window.Crypto
  export default {
    name: 'login',
    mixins: mixins,
    data () {
      return {
        ui: {
          ready: true,
          busying: false
        },
        biz: {
          username: null,
          pwd: null
        }
      }
    },
    methods: {
      // dom event handlers, start
      submit () {
        if (this.check()) {
          window.emitter.emit(MSG_ID.MSG_LOGIN_START)
          http.post('auth.login', {
            account: this.biz.username,
            pwd: crypto.MD5(this.biz.pwd),
            application_id: 1
          }, {}, (res) => {
            window.emitter.emit(MSG_ID.MSG_LOGIN_SUCCESS, res)
          }, (state) => {
            if (state.code !== 2000000) {
              window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, SER_RESP_CODE[state.code])
              return
            }
            switch (state.result) {
              case 2:
                window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, '账号不存在')
                break
              case 3:
                window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, '密码错误')
                break
              case 4:
                window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, '账号已经冻结')
                break
              default:
                window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, '登录失败')
            }
            window.emitter.emit(MSG_ID.MSG_LOGIN_FAIL)
          })
        }
      },
      check () {
        if (this.biz.username && this.biz.pwd) {
          return true
        } else {
          this.ui.ready = false
          window.setTimeout(() => { this.ui.ready = true }, 3000)
        }
        return false
      },
      press (evt) {
        if (evt.keyCode === 13) {
          this.submit()
        }
      }
    },
    mounted () {
      window.emitter.on(MSG_ID.MSG_LOGIN_SUCCESS, (...args) => {
        let res = args[0]
        let user = {
          application_id: 1,
          authedActions: [],
          account: res.account,
          session: res.session,
          accountPwd: crypto.MD5(this.biz.pwd),
          lastLoginTime: Date.now() / 1000 + DEFAULT_EXPIRE
        }
        db.save(K_LOGINED_USER, user)
        window.setTimeout(() => { window.location.replace('/') }, 300)
      })
      window.emitter.on(MSG_ID.MSG_LOGIN_START, (...args) => {
        this.ui.busying = true
      })
      window.emitter.on(MSG_ID.MSG_LOGIN_FAIL, (...args) => {
        this.ui.busying = false
      })
    }
  }
</script>
<style>
</style>


// WEBPACK FOOTER //
// Login.vue?2376c1cb